"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removePrintsPrintableGroups;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const either_1 = require("../../types/either");
const PrintableGroup_1 = require("../../models/printables/PrintableGroup");
/**
 * This function will reduce the number of printable groups in a print set project to the number of prints
 * dictated by the template's max page count.
 * Additionally, it will sort the printable groups such that all of the filled prints are first
 * @param userId
 * @param projectId
 * @param template
 * @param currentPrintableGroups
 * @returns
 */
function removePrintsPrintableGroups(template, currentPrintableGroups) {
  const newPrintableGroups = (0, lodash_clonedeep_1.default)(currentPrintableGroups);
  // Sort the printable groups such that all the filled prints are at the beginning
  // This way, when we chop off printable groups from the end, we preserve as many filled prints as possible
  newPrintableGroups.sort((upgA, upgB) => Number((0, PrintableGroup_1.isPrintableGroupEmpty)(upgA)) - Number((0, PrintableGroup_1.isPrintableGroupEmpty)(upgB)));
  let trimmedPrintableGroups = newPrintableGroups.slice(0, template.pages.max);
  const numPrints = trimmedPrintableGroups.reduce((acc, pg) => acc + pg.qty, 0);
  if (numPrints > template.pages.max) {
    trimmedPrintableGroups = trimmedPrintableGroups.map(pg => Object.assign(Object.assign({}, pg), {
      qty: 1
    }));
  }
  return (0, either_1.right)(trimmedPrintableGroups);
}